/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    Button,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";

const Signin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const history = useNavigate();

    const loginAuth = async (event) => {
        event.preventDefault();
        setLoading(true);
        if (email !== "" && password !== "") {
            console.log(`${process.env.REACT_APP_PUBLIC_SERVER}`);
            try {
                const response = await fetch(`${process.env.REACT_APP_PUBLIC_SERVER}/api/login`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ email, password }),
                });
                if (response.ok) {
                    const data = await response.json();
                    localStorage.setItem("userId",data.userId);
                    localStorage.setItem("token", data.token);
                    localStorage.setItem("userType", data.type);
                    localStorage.setItem("valetId", data.valetId);
                    localStorage.setItem("valetName", data.full_name);
                    localStorage.setItem("cusId", data.cusId);
                    history(`${process.env.REACT_APP_PUBLIC_URL}/dashboard/admin`);
                } else {
                    const errorData = await response.json();
                    toast.error(errorData.message || "Credenciales inválidas");
                }
            } catch (error) {
                console.error(error);
                toast.error("Error al iniciar sesión");
            } finally {
                setLoading(false);
            }
        } else {
            toast.error("Por favor, ingresa email y contraseña");
            setLoading(false);
        }
    };

    const toggleform = () => {
        document.querySelector(".cont").classList.toggle("s--signup");
    };

    return (
        <div className='page-wrapper'>
            <Container fluid={true} className='p-0'>
                <div className='authentication-main m-0 only-login'>
                    <Row>
                        <Col md='12'>
                            <div className='auth-innerright'>
                                <div className='authentication-box'>
                                    <CardBody className='d-flex h-100'>
                                        <div className='cont text-center b-light'>
                                            <div>
                                                <Form className='theme-form' onSubmit={loginAuth}>
                                                    <h4>Iniciar Sesión</h4>
                                                    <h6>Ingresa tu Correo y Contraseña</h6>
                                                    <FormGroup>
                                                        <Label className='col-form-label pt-0'>Correo Electrónico</Label>
                                                        <Input
                                                            className='form-control'
                                                            type='email'
                                                            name='email'
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            placeholder='Correo electrónico'
                                                        />
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label className='col-form-label'>Contraseña</Label>
                                                        <Input
                                                            className='form-control'
                                                            type='password'
                                                            name='password'
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            placeholder='Contraseña'
                                                        />
                                                    </FormGroup>
                                                    <div className='checkbox p-0'>
                                                        <Input id='checkbox1' type='checkbox' />
                                                        <Label for='checkbox1'>Recuérdame</Label>
                                                    </div>
                                                    <FormGroup className='d-flex flex-wrap mt-3 mb-0'>
                                                        {loading ? (
                                                            <Button color='primary d-block w-100' disabled={loading}>
                                                                CARGANDO...
                                                            </Button>
                                                        ) : (
                                                            <Button color='primary d-block w-100' type='submit'>
                                                                INICIAR SESIÓN
                                                            </Button>
                                                        )}
                                                    </FormGroup>
                                                    <div className='login-divider'></div>
                                                    <div className='social mt-3'>
                                                        <Row className='btn-showcase dflex'>
                                                            <Col md='3' sm='6'>
                                                                <Button color='social-btn btn-fb'>
                                                                    Facebook
                                                                </Button>
                                                            </Col>
                                                            <Col md='3' sm='6'>
                                                                <Button color='social-btn btn-twitter'>
                                                                    Twitter
                                                                </Button>
                                                            </Col>
                                                            <Col md='3' sm='6'>
                                                                <div id="signin2"></div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Form>
                                            </div>
                                            <div className='sub-cont'>
                                                <div className='img'>
                                                    <div className='img__text m--up'>
                                                        <h2>¿Nuevo Usuario?</h2>
                                                        <p>¡Regístrate y descubre grandes oportunidades!</p>
                                                    </div>
                                                    <div className='img__text m--in'>
                                                        <h2>¿Ya eres usuario?</h2>
                                                        <p>Si ya tienes una cuenta, inicia sesión. ¡Te extrañamos!</p>
                                                    </div>
                                                    <div className='img__btn' onClick={toggleform}>
                                                        <span className='m--up'>Regístrate</span>
                                                        <span className='m--in'>Inicia Sesión</span>
                                                    </div>
                                                </div>
                                                <div>
                                                    <Form className='theme-form'>
                                                        <h4 className='text-center'>NUEVO USUARIO</h4>
                                                        <h6 className='text-center'>Ingresa tus Datos para Registrarte</h6>
                                                        <Row className='dflex'>
                                                            <Col md='12'>
                                                                <FormGroup>
                                                                    <Input className='btn-pill' type='text' placeholder='Nombre' />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md='12'>
                                                                <FormGroup>
                                                                    <Input className='btn-pill' type='text' placeholder='Apellido' />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <FormGroup>
                                                            <Input className='btn-pill' type='text' placeholder='Correo Electrónico' />
                                                        </FormGroup>
                                                        <FormGroup>
                                                            <Input className='btn-pill' type='password' placeholder='Contraseña' />
                                                        </FormGroup>
                                                        <Row className='dflex'>
                                                            <Col sm='4'>
                                                                <Button color='primary' type='submit'>
                                                                    Regístrate
                                                                </Button>
                                                            </Col>
                                                            <Col sm='8'>
                                                                <div className='text-start mt-2 m-l-20'>
                                                                    ¿Ya eres usuario?
                                                                    <Link to={`${process.env.REACT_APP_PUBLIC_URL}/pages/login`} className='btn-link text-capitalize'>
                                                                        Iniciar Sesión
                                                                    </Link>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        <div className='form-divider'></div>
                                                        <div className='social mt-3'>
                                                            <div className='dflex btn-showcase'>
                                                                <Col sm='4'>
                                                                    <Button color='social-btn btn-fb'>Facebook</Button>
                                                                </Col>
                                                                <Col sm='4'>
                                                                    <Button color='social-btn btn-twitter'>Twitter</Button>
                                                                </Col>
                                                                <Col sm='4'>
                                                                    <div id="signin2"></div>
                                                                </Col>
                                                            </div>
                                                        </div>
                                                    </Form>
                                                </div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <ToastContainer />
            </Container>

        </div>
    );
};

export default Signin;
